import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

interface Props {
  legalName?: string
  tin?: string
}

export const LegalEntityResourceHeader = ({ legalName, tin }: Props) => {
  return (
    <ResourceHeader
      metadata={[
        ...(tin
          ? [
              {
                label: i18n.t('settings.edit_company.tin'),
                value: {
                  content: tin,
                  type: 'text' as const,
                },
              },
            ]
          : []),
      ]}
      title={legalName || ''}
    />
  )
}
